import { atom } from "jotai";
import { GetRequest, GetRequestCached2 } from "../api";
import { urls } from "../constants";
import { insertDispatchDataPromise, insertReceiveAllPromise, insertReceiveDataPromise } from "../../../store/cargoDispatch/dispatch_actions";
import { makePostRequest } from "./commonPromises";

export const destinationCityAtom = atom([])
export const destinationBranchAtom = atom([])
export const memoPrintPopupAtom = atom(false)
export const godownDispatchAtom = atom(false)
export const receivePrintPopupAtom = atom(false)
export const branchTransferFilteredTableRowsAtom = atom([])

export const DispatchBranchListAtom = atom([])
export const fetchBranchesAtom = atom(null, async (get, set, {data,isMultiple=false}) => {
  try {
    const res = await GetRequestCached2(urls.BranchesListCargoSharedAll+"?", data)
    if (res.status === 'Success') {
      const cargoBranches = res.Data.Table.filter((el) => [2, 3].includes(el.BranchTypeID))
      set(DispatchBranchListAtom, cargoBranches) 
			if (cargoBranches.length) {
        if (isMultiple) set(destinationBranchAtom, cargoBranches)
        else set(destinationBranchAtom, [cargoBranches[0]])
      }
    }
  } catch (error) {
    console.error('Error fetching branches:', error)
    set(DispatchBranchListAtom, [])
  }
})
const LOCAL_STORAGE_KEY = 'dispatchmemoPrintResult'
const readInitialValue = () => {
  const raw = sessionStorage.getItem(LOCAL_STORAGE_KEY)
  return raw ? JSON.parse(raw) : []
}
export const insertDispatchResultAtom = atom(readInitialValue())
export const dispatchMemoResultAtom = atom(
  (get) => get(insertDispatchResultAtom),
  (get, set, newValue) => {
    set(insertDispatchResultAtom, newValue)
    sessionStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newValue))
  }
)

export const fetchInsertDispatchAtom = atom(
  null,
  async (get, set, dataArray) => {
    try {
      const results = await Promise.all(dataArray.map(insertDispatchDataPromise));
      const data = results.map(item => {
        const detail = item.DispatchDetails?.[0];
        return detail
          ? {
              VoucherNo: detail.VoucherNo,
              DispatchedToCity: detail.DispatchedToCity,
              DispatchedToBranch: detail.DispatchedToBranch,
            }
          : null;
      }).filter(Boolean);
      set(dispatchMemoResultAtom, data);
      set(memoPrintPopupAtom, true);
    } catch (error) {
      console.error("Error in batch insert:", error);
      set(dispatchMemoResultAtom, []); // Reset state on failure
    }
  }
);
export const fetchInsertDispatchAllAtom = atom(
  null,
  async (get, set, dataArray) => {
    try {
      const results = await Promise.all(dataArray.map(data => makePostRequest(urls.insertDispatchAllV2, data)));
      const data = results
        .flatMap(item => item.DispatchDetails ?? [])
        .reduce((acc, detail) => {
          if (detail?.VoucherNo === null || detail?.VoucherNo === undefined || detail?.VoucherNo === '') return acc;

          if (!acc.has(detail.VoucherNo)) {
            acc.set(detail.VoucherNo, {
              VoucherNo: detail.VoucherNo,
              DispatchedToCity: detail.DispatchedToCity,
              DispatchedToBranch: detail.DispatchedToBranch,
            });
          }
          return acc;
        }, new Map());
      set(dispatchMemoResultAtom, Array.from(data.values()));
      set(memoPrintPopupAtom, true);
    } catch (error) {
      console.error("Error in batch insertDispatchAllV2:", error);
      set(dispatchMemoResultAtom, []); // Reset state on failure
    }
  }
);

export const crossingCityAtom = atom({})
export const crossingBranchAtom = atom({})

const RECEIVE_LOCAL_STORAGE_KEY = 'receivememoPrintResult'
const readReceiveInitialValue = () => {
  const raw = sessionStorage.getItem(RECEIVE_LOCAL_STORAGE_KEY)
  return raw ? JSON.parse(raw) : []
}
export const insertReceiveResultAtom = atom(readReceiveInitialValue())
export const receiveMemoResultAtom = atom(
  (get) => get(insertReceiveResultAtom),
  (get, set, newValue) => {
    set(insertReceiveResultAtom, newValue)
    sessionStorage.setItem(RECEIVE_LOCAL_STORAGE_KEY, JSON.stringify(newValue))
  }
)
export const fetchInsertReceiveAtom = atom(
  null,
  async (get, set, [dataArray,selectedData]) => {
    try {
      const results = await Promise.all(dataArray.map(insertReceiveDataPromise));
      const data=[];
      results.map((item, index)=>{
        if(item.status==="Success"){
        data.push(...dataArray[index].strBookingIDs.split('^'))
      }})
      const filterData=selectedData.filter(item=>data.includes(item.BookingID+''))
      set(receiveMemoResultAtom, filterData);
      set(receivePrintPopupAtom, true);
    } catch (error) {
      console.error("Error in batch insert:", error);
      set(receiveMemoResultAtom, []); // Reset state on failure
    }
  }
);

export const fetchInsertReceiveAllAtom = atom(
  null,
  async (get, set, [bodyArray, selectedData]) => {
    try {

      const results = await Promise.all(
        bodyArray.map(insertReceiveAllPromise)
      )

      const success = results.some(r => r.status === "Success")

      if (success) {
        set(receiveMemoResultAtom, selectedData)
        set(receivePrintPopupAtom, true)
      } else {
        set(receiveMemoResultAtom, [])
      }

    } catch (error) {
      console.error("Receive All Error:", error)
      set(receiveMemoResultAtom, [])
    }
  }
)
